import FeedbackComponent from '@/components/base/FeedbackComponent'
import {StoreNamespace} from '@/globals/StoreNamespaceGlobal'
import {UserModel} from '@/models/User.model'
import GridWidget from '@payroll/grid-widget/src/component/GridWidget.vue'
import {GridColumn} from '@payroll/grid-widget/src/models/GridColumn'
import {KeyValuePair, PortalType, ServiceApi, UserDetailsResponse} from '@payroll/optimus-common'
import {FieldType, SearchFieldModel} from '@payroll/search-results-widget/src/models/SearchField.model'
import Component from 'vue-class-component'
import {Getter} from 'vuex-class'


interface GiladUser {
  id:string;
  identificationNumber: string;
  portalType: string;
  firstName: string;
  lastName: string;
  userType: string;
  phoneNumber: string;
  email: string;
  status: string;
  lastDate: string;
  mailingTypeForDeposits: string;
  mailingTypeForMngCompanyDocs: string;
  lastSuccessfulLogin: string;
}

@Component
export default class UsersGiladComponent extends FeedbackComponent {

  @Getter('userDetails', StoreNamespace.AUTHENTICATION) userDetails!: UserDetailsResponse

  private readonly getPortalTypesPath: string = 'getUserPortalTypes'
  private readonly getTypesOfUsersPath: string = 'getTypesOfUsers'
  private readonly usersPath: string = 'getGiladUsers'
  private readonly createUserPath: string = 'createUser'
  private readonly updateUserPath: string = 'updateGiladUser'

  private searchFieldsUsers: SearchFieldModel[] = []
  private columnsUsers: GridColumn[] = []
  private showModalIsActive: boolean = false
  private userObj: UserModel = {} as UserModel
  private searchObject: any
  private updateMode: boolean = false
  private portalTypes: KeyValuePair[] = []
  private userTypes: KeyValuePair[] = []

  mounted() {
    new ServiceApi()
      .setToken(this.accessToken)
      .setRequestName(this.getPortalTypesPath)
      .get(this)

    new ServiceApi()
      .setToken(this.accessToken)
      .setRequestName(this.getTypesOfUsersPath)
      .get(this)


    this.initColumns()
  }

  private initPortalTypeSearchFields() {
    this.searchFieldsUsers.push({
      label: 'portal_type',
      property: 'portalType',
      fieldType: FieldType.SELECT_FIELD,
      selectOptions: this.portalTypes,
      selectDisplay: 'description',
      unSelectFirst: true
    })
  }

  private initSearchFields(): void {


    this.searchFieldsUsers.push({
      label: 'user_type',
      property: 'userType',
      fieldType: FieldType.SELECT_FIELD,
      selectOptions: this.userTypes,
      selectDisplay: 'description',
      dontAddDefaultSelect: true,
      isRequired: true
    })
    this.searchFieldsUsers.push({
      label: 'id_number',
      property: 'idNumber',
      fieldType: FieldType.TEXT_FIELD,
      maxLength: 16
    })
    this.searchFieldsUsers.push({
      label: 'name',
      property: 'name',
      fieldType: FieldType.TEXT_FIELD,
      maxLength: 50,
      advancedOnly: true
    })
    this.searchFieldsUsers.push({
      label: 'hp_number',
      property: 'hpNumber',
      fieldType: FieldType.TEXT_FIELD,
      maxLength: 50,
      advancedOnly: true
    })
    this.searchFieldsUsers.push({
      label: 'employer_name',
      property: 'employerName',
      fieldType: FieldType.TEXT_FIELD,
      maxLength: 50,
      advancedOnly: true
    })
  }

  private initColumns(): void {
    this.columnsUsers.push({property: 'portalType', header: 'portal_type', hideSorting: true})
    this.columnsUsers.push({property: 'userType', header: 'user_type', hideSorting: true})
    this.columnsUsers.push({property: 'identificationNumber', header: 'id_number_or_hp', hideSorting: true})
    this.columnsUsers.push({property: 'firstName', header: 'firstName', hideSorting: true})
    this.columnsUsers.push({property: 'lastName', header: 'lastName', hideSorting: true})
    this.columnsUsers.push({property: 'phoneNumber', header: 'phoneNum', hideSorting: true})
    this.columnsUsers.push({property: 'email', hideSorting: true})
    this.columnsUsers.push({property: 'mailingTypeForMngCompanyDocs', hideSorting: true})
    this.columnsUsers.push({property: 'mailingTypeForDeposits', hideSorting: true})
    this.columnsUsers.push({property: 'lastSuccessfulLogin', hideSorting: true})
    this.columnsUsers.push({property: 'status', hideSorting: true})
  }


  private getUsersGrid(searchObject: any): void {
    this.searchObject = searchObject
    new ServiceApi()
      .setToken(this.accessToken)
      .setRequestName(this.usersPath)
      .setRequestBody(searchObject)
      .post(this)

  }

  onSuccess(data: any, requestName?: string, message?: string): void {
    switch (requestName) {
      case this.getPortalTypesPath:
        this.portalTypes = data
        this.initPortalTypeSearchFields()
        break
      case this.getTypesOfUsersPath:
        this.userTypes = data
        this.initSearchFields()
        break
      case this.usersPath:
        if (data.resultCount === data.results.length) {
          data.hasMore = false;
        }
        this.$emit('successResults', data);
        break
      case this.createUserPath:
      case  this.updateUserPath:
        this.createdUpdatedUser()
        break
    }
  }

  private createdUpdatedUser() {
    this.$root.$emit('showAlertNotification', {
      toShow: true,
      message: this.updateMode ? 'user_updated_succeeded' : 'user_created_succeeded',
      icon: 'checkCircle',
      secondsToDisappear: 3
    })

    if (!this.searchObject) {
      this.searchObject = {
        pageSize: GridWidget.DEFAULT_PAGE_SIZE
      }
    }
    this.searchObject.pageNumber = 0
    this.getUsersGrid(this.searchObject)
    this.updateMode = false
  }

  public onRowClick(row: GiladUser): any {

    this.updateMode = true
    this.userObj = {
      id: row.id,
      idNumber: row.identificationNumber,
      firstName: row.firstName,
      lastName: row.lastName,
      phoneNum: row.phoneNumber,
      email: row.email,
      isActive: row.status === this.$t('active'),
      createImpersonator: true,
      createMemberImpersonator: true,
      isSuperUser: true,
      portalType: {description : row.portalType} as KeyValuePair,
      userType: row.userType
    }
    this.showModalIsActive = true

  }

  public onAddClicked(): void {
    this.userObj = {
      idNumber: '',
      firstName: '',
      lastName: '',
      phoneNum: '',
      email: '',
      isActive: true,
      createImpersonator: false,
      createMemberImpersonator: false,
      isSuperUser: false,
      portalType: {value: '4', description: this.$t(PortalType.BACKOFFICE).toString()}
    }
    this.showModalIsActive = true
  }

  public onCreateUpdateUser(): any {
    this.showModalIsActive = false

    if (this.updateMode) {
      let id = this.userObj.id
      delete this.userObj.id

      new ServiceApi()
        .setToken(this.accessToken)
        .setPathVariable(id || '')
        .setRequestName(this.updateUserPath)
        .setRequestBody(this.userObj)
        .put(this)
    } else {
      new ServiceApi()
        .setToken(this.accessToken)
        .setRequestName(this.createUserPath)
        .setRequestBody(this.userObj)
        .post(this)
    }
  }

  modalClosed() {
    this.updateMode = false
  }

  get doesUserEmailOrPhoneNumberExist(): boolean {
    if (this.userObj.phoneNum) {
      return false
    }
    if (this.userObj.email) {
      return false
    }
    return true;
  }

}
